//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import FilesField from '../../components/File/FilesField.vue'
import FilesGroup from '../../components/File/FilesGroup.js'
import RequestReportsFilesSelector from './RequestReportsFilesSelector'

export default {
  name: 'RequestFiles',
  components: {
    FilesField
  },
  props: {
    request: {
      type: Object,
      default () {
        return {}
      }
    },
    modeEdit: {
      type: Boolean,
      default: false
    },
    filesGroup: {
      type: FilesGroup,
      required: true
    },
    contentType: {
      type: String,
      default: null
    },
    original: {
      type: Boolean,
      default: false
    },
    isInitialize: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    imageContent: function () {
      return this.contentType === 'image'
    }
  },
  methods: {
    onRemoveFile: function ({ file: fileWrapper, filesGroup }) {
      filesGroup.removeFile(fileWrapper)
    },
    onRemoveSelectedFiles: function () {
      this.$d_ask({
        callback: () => {
          this.filesGroup.removeSelectedFiles({
            target: this
          })
        },
        header: 'Удалить выбранные файлы?'
      })
    },
    onRotateSelectedImages: function (right = true) {
      this.filesGroup.rotateSelectedImages(right)
    },
    onSelectReportFiles: function () {
      this.$d.dialog(this).show({
        maximized: true,
        persistent: true,
        headerLabel: 'Выбор ' + (this.imageContent ? 'фотографий' : 'файлов'),
        contentComponent: RequestReportsFilesSelector,
        contentProps: {
          request: this.request,
          filesGroup: this.filesGroup,
          contentType: this.contentType,
          reportsDocuments: this.reportsDocuments,
          callback: (data, confirmed) => {
            if (confirmed) {
              data.filesToAdd.forEach(fileWrapper => {
                this.filesGroup.pushFile(fileWrapper.document)
              })
              data.filesToRemove.forEach(fileWrapper => {
                this.filesGroup.deleteFile(fileWrapper) // TODO
              })
            }
          }
        }
      })
    }
  }
}

